var gql = require("@apollo/client").gql;

const SITE_CONFIG_REGION_CONTACTS_QUERY = gql`
	query SiteConfig {
		siteConfig {
			code
			contacts {
				shema_proezda
				passage
				office_address
				post_address
				additional_contacts
				additional_address
				contact_phone
				email_for_partners
			}
		}
	}
`;

module.exports = SITE_CONFIG_REGION_CONTACTS_QUERY;
